/** UI copy for Sidekick Download — Deutsch + English */
export const SUPPORTED = [
  { code: 'de', label: 'Deutsch', flag: 'DE' },
  { code: 'en', label: 'English', flag: 'GB' },
];

export const strings = {
  de: {
    brand: 'Sidekick Download',
    brandDomain: 'sidekickdownload.com',
    nav: {
      home: 'Start',
      discover: 'Entdecken',
      features: 'Funktionen',
      advantages: 'Vorteile',
      faq: 'FAQ',
      contact: 'Kontakt',
    },
    headerCta: 'Jetzt starten',
    hero: {
      badge: 'KI-Portal · Dein digitaler Partner',
      titleA: 'Partner werden',
      titleB: 'mit KI',
      titleC: 'Intelligente Hilfe, wenn du sie brauchst.',
      lead:
        'Sidekick Download ist dein KI-Portal — smarte Tools, Automatisierungen und personalisierte Unterstützung, die dir beim Arbeiten, Erstellen und Organisieren hilft.',
      ctaPrimary: 'Jetzt starten',
      ctaSecondary: 'Mehr erfahren',
      legal:
        'Kostenpflichtiges wöchentliches Abonnement. Bezahlung über Mobile Billing (Mobilfunkrechnung). Mit Abschluss akzeptieren Sie unsere AGB. Kündigung jederzeit möglich. Support: support@sidekickdownload.com. Anbieter: Niffo Mobile B.V.',
      statTitle: '10 000+ Nutzer',
      statSub: 'produktiver mit KI',
      priceChip: 'Wöchentliches Abo',
    },
    discover: {
      kicker: 'Entdecken',
      title: 'Dein KI-Partner für',
      titleGrad: 'den Alltag',
      body:
        'Ob Inhalte erstellen, Prozesse automatisieren oder personalisierte Empfehlungen — Sidekick Download passt sich deinen Bedürfnissen an und unterstützt dich bei jeder digitalen Aufgabe.',
      devicesTitle: 'Überall verfügbar',
      devicesSub: 'Browser, Smartphone oder Tablet — ohne Installation.',
    },
    features: {
      kicker: 'Im Portal',
      items: [
        {
          title: 'KI-Assistent',
          description: 'Persönliche KI-Unterstützung für Texte, Ideen und Entscheidungen — immer an deiner Seite.',
        },
        {
          title: 'Automatisierung',
          description: 'Wiederkehrende digitale Prozesse optimieren und Zeit sparen.',
        },
        {
          title: 'Inhalte generieren',
          description: 'Texte, Daten und Inhalte erstellen und verwalten — schnell und individuell.',
        },
        {
          title: 'Personalisiert',
          description: 'Einstellungen und Präferenzen anpassen für relevantere Ergebnisse.',
        },
        {
          title: 'Speichern & Teilen',
          description: 'Inhalte sicher speichern und bei Bedarf mit anderen teilen.',
        },
        {
          title: 'Produktivität',
          description: 'Effizienter arbeiten mit intelligenten Tools und smarten Workflows.',
        },
      ],
    },
    how: {
      kicker: 'So funktioniert\'s',
      title: 'In drei Schritten',
      titleGrad: 'zum Sidekick',
      intro:
        'Registrieren, personalisieren und loslegen — Sidekick Download macht KI für jeden zugänglich.',
      blocks: [
        {
          title: 'Registrieren',
          description: 'Erstelle dein Konto mit E-Mail und Passwort — in wenigen Sekunden startklar.',
          points: ['Schnelle Anmeldung', 'Sichere Zugangsdaten', 'Sofortiger Zugang'],
        },
        {
          title: 'Partner werden',
          description: 'Verbinde dich mit deinem KI-Sidekick und passe Einstellungen an deine Bedürfnisse an.',
          points: ['Personalisierte Präferenzen', 'Individuelle Tools', 'Relevante Ergebnisse'],
        },
        {
          title: 'Produktiv arbeiten',
          description: 'Nutze smarte Automatisierungen, generiere Inhalte und optimiere deine digitalen Prozesse.',
          points: ['KI-gestützte Vorschläge', 'Inhalte speichern', 'Effizient organisieren'],
        },
        {
          title: 'Jederzeit unterstützt',
          description: 'Dein digitaler Sidekick ist rund um die Uhr verfügbar — auf allen Geräten.',
          points: ['Browser & Mobile', 'Moderne Sicherheit', 'Support per E-Mail'],
        },
      ],
    },
    advantages: {
      kicker: 'Deine Vorteile',
      title: 'Arbeite smarter.',
      titleGrad: 'Mit KI an deiner Seite.',
      intro: 'Sidekick Download unterstützt dich bei produktiveren, effizienteren und kreativeren digitalen Aufgaben.',
      quote: 'Dein KI-Partner für jeden Tag.',
      quoteSub: 'Zeit sparen, produktiver werden und kreative Lösungen schneller entwickeln — mit personalisierter KI-Unterstützung.',
      bullets: ['Zeit sparen durch Automatisierung.', 'Personalisierte KI-Unterstützung.', 'Effizienter digital arbeiten.'],
      cta: 'Jetzt starten',
      panelTitle: 'KI-Tools',
      panelKicker: 'SMARTE LÖSUNGEN',
      panelBody: 'Verschiedene KI-Tools und Automatisierungen — alles an einem Ort.',
      panelSub: 'Inhalte generieren, Prozesse optimieren und produktiver arbeiten — mit deinem digitalen Sidekick.',
      imageAlt: 'Person arbeitet mit KI am Laptop',
      panelAlt: 'Digitale KI-Oberfläche',
    },
    cta: {
      badge: 'Bereit für deinen Sidekick?',
      title: 'Starte jetzt',
      titleSub: 'mit Sidekick Download.',
      body: 'Schalte den vollen Funktionsumfang frei — personalisierte KI-Tools, Automatisierungen und smarte digitale Lösungen.',
      perks: [
        'Voller Portal-Zugang',
        'Personalisierte KI-Tools',
        'Jederzeit kündbar',
        'Alle modernen Browser',
      ],
      button: 'Jetzt starten',
      priceLine: 'Wöchentliches Abonnement — Bezahlung über Mobile Billing.',
      helpLine: 'Support: support@sidekickdownload.com',
      legalBox:
        'Sidekick Download ist ein kostenpflichtiger KI-Service. Mit Abschluss des Abonnements akzeptieren Sie unsere AGB. Das Abonnement verlängert sich automatisch, sofern es nicht gekündigt wird. Bezahlung über Mobile Billing (Mobilfunkrechnung). Anbieter: Niffo Mobile B.V., Stationsplein 28, 1382 AD Weesp, Niederlande.',
    },
    faq: {
      kicker: 'FAQ',
      title: 'Häufige',
      titleGrad: 'Fragen',
      intro: 'Antworten auf die wichtigsten Fragen zu Sidekick Download.',
      items: [
        {
          q: 'Was ist Sidekick Download?',
          a: 'Sidekick Download ist ein digitaler KI-Service, der smarte Tools und Lösungen bereitstellt, um deinen Alltag einfacher, effizienter und produktiver zu gestalten.',
        },
        {
          q: 'Wie registriere ich mich?',
          a: 'Klicke auf „Jetzt starten", gib deine E-Mail-Adresse und ein Passwort ein — danach kannst du direkt loslegen.',
        },
        {
          q: 'Was kostet Sidekick Download?',
          a: 'Sidekick Download ist ein kostenpflichtiger Service als wöchentliches Abonnement. Die Bezahlung erfolgt über Mobile Billing (Mobilfunkrechnung).',
        },
        {
          q: 'Kann ich mein Abo kündigen?',
          a: 'Ja, du kannst dein Abonnement jederzeit kündigen. Die Kündigung wird zum Ende der laufenden Abrechnungsperiode wirksam.',
        },
        {
          q: 'Welche Geräte werden unterstützt?',
          a: 'Sidekick Download funktioniert auf aktuellen Browsern (Chrome, Safari, Firefox, Edge) sowie auf Smartphones und Tablets.',
        },
      ],
      contactTitle: 'Noch Fragen?',
      contactLead: 'Schreib uns — wir helfen gerne weiter.',
      email: 'support@sidekickdownload.com',
    },
    footer: {
      blurb:
        'Sidekick Download — dein KI-Portal für smarte Tools und personalisierte Unterstützung. Anbieter: Niffo Mobile B.V.',
      legalShort:
        'Kostenpflichtiges wöchentliches Abo. Kündigung jederzeit möglich. Siehe AGB für Details zu Abrechnung und Widerrufsrecht.',
      navTitle: 'Navigation',
      contactTitle: 'Kontakt',
      cta: 'Jetzt starten →',
      copyright: 'Sidekick Download. Niffo Mobile B.V. Alle Rechte vorbehalten.',
      agb: 'AGB',
      privacy: 'Datenschutz',
      help: 'Hilfe',
      imprint: 'Impressum',
      widerruf: 'Widerruf',
    },
  },
  en: {
    brand: 'Sidekick Download',
    brandDomain: 'sidekickdownload.com',
    nav: {
      home: 'Home',
      discover: 'Discover',
      features: 'Features',
      advantages: 'Benefits',
      faq: 'FAQ',
      contact: 'Contact',
    },
    headerCta: 'Get started',
    hero: {
      badge: 'AI portal · Your digital partner',
      titleA: 'Partner with',
      titleB: 'AI',
      titleC: 'Smart help whenever you need it.',
      lead:
        'Sidekick Download is your AI portal — smart tools, automations, and personalised support to help you work, create, and organise more effectively.',
      ctaPrimary: 'Get started',
      ctaSecondary: 'Learn more',
      legal:
        'Paid weekly subscription. Payment via mobile billing. By subscribing you accept our terms. Cancel anytime. Support: support@sidekickdownload.com. Provider: Niffo Mobile B.V.',
      statTitle: '10,000+ users',
      statSub: 'more productive with AI',
      priceChip: 'Weekly subscription',
    },
    discover: {
      kicker: 'Discover',
      title: 'Your AI partner for',
      titleGrad: 'everyday tasks',
      body:
        'Whether creating content, automating processes, or getting personalised recommendations — Sidekick Download adapts to your needs and supports every digital task.',
      devicesTitle: 'Available everywhere',
      devicesSub: 'Browser, smartphone, or tablet — no installation required.',
    },
    features: {
      kicker: 'Inside the portal',
      items: [
        {
          title: 'AI assistant',
          description: 'Personal AI support for texts, ideas, and decisions — always by your side.',
        },
        {
          title: 'Automation',
          description: 'Optimise recurring digital processes and save time.',
        },
        {
          title: 'Content generation',
          description: 'Create and manage texts, data, and content — fast and tailored.',
        },
        {
          title: 'Personalised',
          description: 'Adjust settings and preferences for more relevant results.',
        },
        {
          title: 'Save & share',
          description: 'Securely store content and share with others when needed.',
        },
        {
          title: 'Productivity',
          description: 'Work more efficiently with intelligent tools and smart workflows.',
        },
      ],
    },
    how: {
      kicker: 'How it works',
      title: 'Three steps',
      titleGrad: 'to your sidekick',
      intro:
        'Register, personalise, and go — Sidekick Download makes AI accessible for everyone.',
      blocks: [
        {
          title: 'Register',
          description: 'Create your account with email and password — ready in seconds.',
          points: ['Quick sign-up', 'Secure credentials', 'Instant access'],
        },
        {
          title: 'Partner up',
          description: 'Connect with your AI sidekick and adjust settings to your needs.',
          points: ['Personal preferences', 'Individual tools', 'Relevant results'],
        },
        {
          title: 'Work productively',
          description: 'Use smart automations, generate content, and optimise your digital workflows.',
          points: ['AI-powered suggestions', 'Save content', 'Organise efficiently'],
        },
        {
          title: 'Always supported',
          description: 'Your digital sidekick is available around the clock — on all devices.',
          points: ['Browser & mobile', 'Modern security', 'Email support'],
        },
      ],
    },
    advantages: {
      kicker: 'Your benefits',
      title: 'Work smarter.',
      titleGrad: 'With AI by your side.',
      intro: 'Sidekick Download helps you tackle digital tasks more productively, efficiently, and creatively.',
      quote: 'Your AI partner for every day.',
      quoteSub: 'Save time, boost productivity, and develop creative solutions faster — with personalised AI support.',
      bullets: ['Save time through automation.', 'Personalised AI support.', 'Work digitally more efficiently.'],
      cta: 'Get started',
      panelTitle: 'AI tools',
      panelKicker: 'SMART SOLUTIONS',
      panelBody: 'Various AI tools and automations — all in one place.',
      panelSub: 'Generate content, optimise processes, and work more productively — with your digital sidekick.',
      imageAlt: 'Person working with AI on laptop',
      panelAlt: 'Digital AI interface',
    },
    cta: {
      badge: 'Ready for your sidekick?',
      title: 'Start now',
      titleSub: 'with Sidekick Download.',
      body: 'Unlock the full feature set — personalised AI tools, automations, and smart digital solutions.',
      perks: [
        'Full portal access',
        'Personalised AI tools',
        'Cancel anytime',
        'All modern browsers',
      ],
      button: 'Get started',
      priceLine: 'Weekly subscription — payment via mobile billing.',
      helpLine: 'Support: support@sidekickdownload.com',
      legalBox:
        'Sidekick Download is a paid AI service. By subscribing you accept our terms. The subscription renews automatically unless cancelled. Payment via mobile billing. Provider: Niffo Mobile B.V., Stationsplein 28, 1382 AD Weesp, Netherlands.',
    },
    faq: {
      kicker: 'FAQ',
      title: 'Common',
      titleGrad: 'questions',
      intro: 'Answers to the most important questions about Sidekick Download.',
      items: [
        {
          q: 'What is Sidekick Download?',
          a: 'Sidekick Download is a digital AI service providing smart tools and solutions to make your everyday life easier, more efficient, and more productive.',
        },
        {
          q: 'How do I register?',
          a: 'Click "Get started", enter your email address and a password — then you can start right away.',
        },
        {
          q: 'What does Sidekick Download cost?',
          a: 'Sidekick Download is a paid service offered as a weekly subscription. Payment is via mobile billing.',
        },
        {
          q: 'Can I cancel my subscription?',
          a: 'Yes, you can cancel anytime. Cancellation takes effect at the end of the current billing period.',
        },
        {
          q: 'Which devices are supported?',
          a: 'Sidekick Download works on current browsers (Chrome, Safari, Firefox, Edge) as well as smartphones and tablets.',
        },
      ],
      contactTitle: 'Still have questions?',
      contactLead: 'Write to us — we\'re happy to help.',
      email: 'support@sidekickdownload.com',
    },
    footer: {
      blurb:
        'Sidekick Download — your AI portal for smart tools and personalised support. Provider: Niffo Mobile B.V.',
      legalShort:
        'Paid weekly subscription. Cancel anytime. See terms for billing and withdrawal details.',
      navTitle: 'Navigate',
      contactTitle: 'Contact',
      cta: 'Get started →',
      copyright: 'Sidekick Download. Niffo Mobile B.V. All rights reserved.',
      agb: 'Terms',
      privacy: 'Privacy',
      help: 'Help',
      imprint: 'Imprint',
      widerruf: 'Withdrawal',
    },
  },
};
